import {
  Card,
  Typography,
} from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2"; // Grid version 2
import MonetaryText from "../../MonetaryText";
import { useClient } from "../../../context/ClientProvider";
import { useState, useEffect } from "react";

function LiveBalanceWidget({ balance }) {
  const [localPalette, setLocalPalette] = useState(null);
  const { useGetConfig } = useClient();
  const { clientConfig } = useGetConfig();
  useEffect(() => {
    if (clientConfig && clientConfig?.theme?.palette) {
      setLocalPalette(clientConfig.theme.palette);
    }
  }, [clientConfig]);

  return localPalette && (
    <Grid>
      <Card
        id="balance-container"
        sx={{
          textAlign: "center",
          backgroundColor: "primary.dark",
          color: "primary.contrastText",
          borderRadius: 0,
          borderLeft: `10px solid ${localPalette.secondary.dark}`
        }}>
        <Typography
          id="balance-label"
          fontWeight={"bold"}
          fontSize={28}
          paddingTop={0.5}
        >
          Current balance
        </Typography>
        <Typography
          id="balance"
          fontSize={46}
          fontWeight={"bold"}
          paddingBottom={-1}
        >
          <MonetaryText value={balance} />
        </Typography>
      </Card>
    </Grid>
  )
}

export default LiveBalanceWidget;